<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <layout-tabbar :activeColor="$colorConfig.primaryColor" :tab-list="tabbarList"></layout-tabbar>
  </div>
</template>
<script>
import tabbar from '@/router/routes/tabbarRoute.js'
import layoutTabbar from '@/components/Tabbar.vue'
import configColor from '@/config/color.config'
export default {
  name: 'Tabbar',
  components: {
    layoutTabbar
  },
  data () {
    return {
      active: 0,
      clientHeight: document.documentElement.clientHeight,
      showBtn: true,
      configColor
    };
  },
  computed: {
    tabbarList () {
      const list = tabbar[0].children.map(item => {
        return {
          name: item.meta.name,
          path: item.path,
          icon: item.meta.icon
        }
      })
      return list
    }
  }
};
</script>
<style lang="scss" scoped>
</style>